import React from "react";
import { Modal } from "react-bootstrap";
import styles from "./invoiceModal.module.scss";

const InvoiceModal = ({
  show,
  handleClose,
  selectedInvoice,
  setSelectedInvoice,
}) => {
  const BASE_URL = "https://api.xwguarantee.com/";

  const downloadImage = async (url, filename) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      // تنظيف
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Failed to download image:", error);
    }
  };

  return (
    <div>
      <Modal
        size="lg"
        show={show}
        onHide={() => {
          handleClose();
          setSelectedInvoice(null);
        }}
        centered
        className={styles.invoiceModal}
      >
        <Modal.Header>
          <Modal.Title> البيانات </Modal.Title>
          <button
            onClick={() => {
              handleClose();
              setSelectedInvoice(null);
            }}
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M11.1472 10.2603L6.88464 6.00008L11.1472 1.77126C11.3608 1.52386 11.3492 1.15258 11.1206 0.919132C10.892 0.685689 10.5235 0.66878 10.2747 0.880324L5.99973 5.07777L1.79953 0.848953C1.55647 0.605687 1.16391 0.605687 0.920852 0.848953C0.802877 0.966762 0.736518 1.12713 0.736518 1.29442C0.736518 1.46172 0.802877 1.62208 0.920852 1.73989L5.11482 5.96244L0.852303 10.185C0.734328 10.3028 0.667969 10.4632 0.667969 10.6304C0.667969 10.7977 0.734328 10.9581 0.852303 11.0759C0.969908 11.1934 1.12912 11.2588 1.29476 11.2579C1.45736 11.2589 1.61391 11.1958 1.73098 11.0822L5.99973 6.8471L10.2747 11.1512C10.3923 11.2687 10.5515 11.3341 10.7172 11.3332C10.8807 11.3325 11.0373 11.2671 11.1534 11.1512C11.2706 11.0326 11.3358 10.8717 11.3346 10.7044C11.3335 10.5371 11.266 10.3772 11.1472 10.2603Z" />
            </svg>
          </button>
        </Modal.Header>

        <Modal.Body>
          <div className="table-responsive">
            {/* صور الفاتورة */}
            <div className="row gap-3 mb-4  ">
              <div className="col-md-5 col-lg-4">
                <div className="img-holder">
                  <button
                    onClick={() =>
                      downloadImage(
                        `${BASE_URL}${selectedInvoice?.frontPurchaseImage}`,
                        "frontPurchaseImage.jpg"
                      )
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#3076f4"
                      className="bi bi-file-earmark-arrow-down"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z" />
                      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                    </svg>
                    <h4>صورة الشراء الأمامية</h4>
                  </button>
                </div>
              </div>
              <div className="col-md-5 col-lg-4">
                <div className="img-holder">
                  <button
                    onClick={() =>
                      downloadImage(
                        `${BASE_URL}${selectedInvoice?.purchaseImage}`,
                        "purchaseImage.jpg"
                      )
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#3076f4"
                      className="bi bi-file-earmark-arrow-down"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z" />
                      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                    </svg>
                    <h4>صورة الشراء</h4>
                  </button>
                </div>
              </div>
            </div>

            {/* جدول البيانات */}
            <table className="table table-bordered text-end">
              <thead className="table-light">
                <tr>
                  <th className="fw-bold fs-5">البيان</th>
                  <th className="fw-bold fs-5">القيمة</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="fw-semibold">الإسم</td>
                  <td>{selectedInvoice?.userName}</td>
                </tr>
                <tr>
                  <td className="fw-semibold">البريد الإلكترونى</td>
                  <td>{selectedInvoice?.email}</td>
                </tr>
                <tr>
                  <td className="fw-semibold">رقم الهاتف</td>
                  <td>{selectedInvoice?.phone}</td>
                </tr>
                <tr>
                  <td className="fw-semibold">اسم المحل</td>
                  <td>{selectedInvoice?.shopName}</td>
                </tr>
                <tr>
                  <td className="fw-semibold">المدينة</td>
                  <td>{selectedInvoice?.city}</td>
                </tr>
                <tr>
                  <td className="fw-semibold">موديل الجهاز</td>
                  <td>{selectedInvoice?.device?.name || "-"}</td>
                </tr>
                <tr>
                  <td className="fw-semibold">الرقم التسلسلي للجهاز (IMEE)</td>
                  <td>{selectedInvoice?.imee}</td>
                </tr>
                <tr>
                  <td className="fw-semibold">الحالة</td>
                  <td>
                    {selectedInvoice?.status === "pending"
                      ? "تحت المراجعة"
                      : "تمت الموافقة عليه"}
                  </td>
                </tr>
                <tr>
                  <td className="fw-semibold">تاريخ التفعيل:</td>
                  <td>
                    {new Date(selectedInvoice?.createdAt).toLocaleDateString(
                      "ar-EG",
                      {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      }
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default InvoiceModal;
